module.exports = __webpack_public_path__ + "img/tire-flat.495ab758.svg";